'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseCharges', ['$scope', function ($scope) {
        $scope.resetLicense();
        $scope.columns = [
            {
                label: 'Name',
                field: 'name',
                link: {
                    state: 'internal.licensing.license.charge',
                    params: [
                        {
                            name: 'licenseChargeID',
                            field: 'id'
                        },
                        {
                            name: 'license_charge',
                            field: ''
                        }
                    ]
                }
            },
            {
                label: 'Amount',
                field: 'value',
                type: 'money'
            },
            {
                label: 'Additional Charges',
                field: 'additional_charge',
                type: 'money'
            }
        ]

        $scope.getTotalCharges = function (additional) {
            var amount = 0;

            if ($scope.license != null) {
                $scope.license.license_charges.forEach(function (charge) {
                    if (additional && charge.additional_charge != null) {
                        amount += charge.additional_charge;
                    }
                    else if (!additional && charge.value != null) {
                        amount += charge.value;
                    }
                })
            }
            return amount;
        }
    }])
;